<template>
  <b-modal
    ref="vpnServerParams"
    centered
    size="lg"
    title="Parameters of VPN server"
    hide-footer
    body-class="pb-0"
    scrollable
    @hidden="unselectVpnServer()">
    <b-form-group
      v-for="(param, index) in selectedVpnServer.parameters"
      :key="`dataset-${index}`">
      <b-row>
        <b-col
          col
          lg="4"
          md="4"
          sm="3"
          cols="3"
          class="pr-2 pr-md-4">
          <b-form-input
            readonly
            :value="param.name" />
        </b-col>
        <b-col
          col
          lg="8"
          md="8"
          sm="9"
          cols="9"
          class="d-flex pl-2 pl-md-4">
          <b-form-textarea
            :value="param.code"
            rows="4"
            no-resize
            readonly
            placeholder="Value" />
        </b-col>
      </b-row>
    </b-form-group>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import { showModal, hideModal } from '@/core/utils'
import { UNSELECT_VPN_SERVER } from '@/core/services/store/vpn-servers.module'

export default {
  name: 'ModalVpnServerParams',
  data() {
    return {
      showModal,
      hideModal,
    }
  },
  computed: {
    ...mapGetters([
      'selectedServer',
      'selectedServerId',
      'FailedDataGetStatus',
      'serverStatusBadge',
      'serversResponses',

      'vpnServersList',
      'vpnServersEmpty',
      'selectedVpnServer',
      'totalVpnServers',
      'vpnServerParamsLength',
      'vpnServerInstallBadge',
      'selectedVpnServerExist',
      'someVpnServerPending',
      'noneVpnServerPending',
      'installedVpnServersCount',
      'vpnServersResponses'
    ])
  },
  mounted() {
    eventBus.$on('openModal', type => { this.showModal(type) })
  },
  destroyed() {
    eventBus.$off('openModal')
  },
  methods: {
    unselectVpnServer() {
      this.$store.commit(UNSELECT_VPN_SERVER)
    },
  }
}
</script>
